import Grid from '../../components/Grid';
import InternacionService from '../../services/internacion_service.js';
import routeService from '../../services/route_service.js';
import AlertService from '../../services/alert_service.js';
import GeneralService from '../../services/general_service.js';
import LoginService from '../../services/login_service.js';
import PacienteService from '../../services/paciente_service.js';
import ObraSocialService from '../../services/obras_sociales_service.js';
import DatosParametricosService from '../../services/datos_parametricos_service.js';
import SedeService from '../../services/sede_service.js';

const alertService = new AlertService();
const loginService = new LoginService();
const generalService = new GeneralService();
const internacionService = new InternacionService();
const pacienteService = new PacienteService();
const obraSocialService = new ObraSocialService();
const sedeService = new SedeService();
const datosParametricosService = new DatosParametricosService();


let _this;
let search =JSON.stringify({nombrePaciente: '', apellidoPaciente: '', dniPaciente: '', idObraSocialPaciente: '', 
							historiaClinicaPaciente: '', sexoPaciente: '', activoInternacion: '', idSedeInternacion: '',
							fechaInternacionDesde: '', fechaInternacionHasta: '', edadDesde: '', edadHasta: '', idDiagnosticoInternacion: ''});
export default {
	name: 'internaciones',
	components: { Grid },
	props: {
		titulo: String, 
		actions: Array,
		noDataGet: Boolean,
		columns: Array,
		cellClick: {
			type: Function,
			default() {
				return true;
			}
		}		
	},
	data: function() {
		return {
			loginService: loginService,
			searchQuery: '',
			generalService: generalService,
			search: JSON.parse(search),
			submited: false,
			buscando: false,
			diagnosticos:[],
			sedes: [],
			data: [],
		} 
	}, 
	created: function () {
		this.submited = false;
		_this = this;
		if(!loginService.hasPermission("listado", "internaciones")) {
			routeService.goToHome();
			return;
		}
		this.getObrasSociales();
		if(!this.noDataGet)
			this.getData();
		this.getDiagnosticos();
		this.getSedes();
	}, 
	methods: { 
		getData: function () {
			internacionService.get(this.search).then(function(response) {
				_this.data = [];
				if(response.body == null) {
					alertService.showAlert(_this.$bvModal, 'danger', 'Error!', 'Ocurrio un error al obtener los datos');
					return;
				}
				if(response.body && response.body.status == 'ERROR') {
					alertService.showAlert(_this.$bvModal, 'danger', 'Error!', response.body.message);
					return;
				}
				if(response.body.length > 0) {
					for (let value of response.body) {
						_this.data.push({
							idInternacion: value.idInternacion,
							idPacienteInternacion: value.idPacienteInternacion,
							tipoInternacion: value.tipoInternacion,
							ambulatorioInternacion: value.ambulatorioInternacion == 1 ? 'SI' : 'NO',
							camaInternacion: value.camaInternacion,
							diagnosticoInternacion: value.diagnosticoInternacion,
							idReInternacion: value.idReInternacion,
							idUserAnteriorInternacion: value.idUserAnteriorInternacion,
							pacienteInternacion: pacienteService.formatPaciente(value.pacienteInternacion),
							nomyApPaciente: value.pacienteInternacion.nombrePaciente + " " + value.pacienteInternacion.apellidoPaciente,
							dniPaciente: value.pacienteInternacion.dniPaciente,
							edadPaciente: value.pacienteInternacion.edadPaciente,
							nroHcPaciente: value.pacienteInternacion.nroHcPaciente.substring(0, value.pacienteInternacion.nroHcPaciente.indexOf(" - ")),
							obraSocialPaciente: value.pacienteInternacion.obraSocialPaciente.nombreObraSocial,
							sexoPaciente: value.pacienteInternacion.sexoPaciente == 1 ? 'M' : 'F',
							idUserInternacion: value.idUserInternacion,
							idStaffInternacion: value.idStaffInternacion,
							nombreStaffInternacion: value.nombreStaffInternacion,
							idEspecialidadInternacion: value.idEspecialidadInternacion,
							especialidadInternacion: value.especialidadInternacion.descripcionDatoParametrico,
							activoInternacion: value.activoInternacion == 1 ? 'SI' : 'NO',
							col1Internacion: value.col1Internacion,
							col2Internacion: value.col2Internacion,
							col3Internacion: value.col3Internacion,
						}); 
					} 
				} 
			}, function(error) { 
				_this.submited = false;
				generalService.showRequestErrors(error, _this.$bvModal);
				return;
			});
		},
		async desactivar(item) {
			try {
				if(!loginService.hasPermission("eliminar", "internaciones")) {
					routeService.goToHome();
					return;
				}
				let conf = await alertService.showConfirm(_this.$bvModal, 'warning', 'Confirmar', '¿Esta seguro que desea desactivar el registro id: ' + item.idInternacion + '?');
				if(conf) {
					_this.submited = true;
					internacionService.remove({id: item.idInternacion}).then(function(response) {
						_this.submited = false; 
						if(response.body && response.body.status == 'success') {
							item.activoObrasSocial = 'NO';
							alertService.showAlert(_this.$bvModal, 'success', 'Confirmación!', 'Registro desactivado con exito.');
						}
					}, function(error) { 
						_this.submited = false;
						generalService.showRequestErrors(error, _this.$bvModal);
						return;
					});
				} 
			} catch(err) {
				return err;
			}
		}, 
		async activar(item) {
			try {
				if(!loginService.hasPermission("activar", "internaciones")) {
					routeService.goToHome();
					return;
				}
				let conf = await alertService.showConfirm(_this.$bvModal, 'warning', 'Confirmar', '¿Esta seguro que desea activar el registro id: ' + item.idInternacion + '?');
				if(conf) {
					_this.submited = true;
					internacionService.activate({id: item.idInternacion}).then(function(response) {
						_this.submited = false; 
						if(response.body && response.body.status == 'success') {
							item.activoObrasSocial = 'SI';
							alertService.showAlert(_this.$bvModal, 'success', 'Confirmación!', 'Registro activado con exito.');
						}
					}, function(error) { 
						_this.submited = false;
						generalService.showRequestErrors(error, _this.$bvModal);
						return;
					});
				} 
			} catch(err) {
				return err;
			}
		}, 
		agregar: function () {
			if(!loginService.hasPermission("alta", "internaciones")) {
				routeService.goToHome();
				return;
			}
			routeService.goTo('internacion');
		},
		editar: function (item) {
			if(!loginService.hasPermission("editar", "internaciones")) {
				routeService.goToHome();
				return;
			}
			routeService.goTo('internacion/' + item.idInternacion);
		},
		getObrasSociales: function() {
			_this.obrasSociales = [];
			obraSocialService.get({}).then(function(response) {					
				if(response.body == null) {
					alertService.showAlert(_this.$bvModal, 'danger', 'Error!', 'Ocurrio un error al obtener los datos');
					return;
				}
				if(response.body && response.body.status == 'ERROR') {
					alertService.showAlert(_this.$bvModal, 'danger', 'Error!', response.body.message);
					return;
				}
				if(response.body.length > 0) {
					for (let value of response.body) {
						if(value.activoObraSocial == 1) {
							_this.obrasSociales.push(value);
						}
					}
				} 
			}, function(error) { 
				_this.submited = false;
				generalService.showRequestErrors(error, _this.$bvModal);
				return;
			});
		},
		getDiagnosticos: function() {
			_this.diagnosticos = [{idDatoParametrico:"", descripcionDatoParametrico:"Diagnostico"}];
			datosParametricosService.getDiagnosticos({}).then(function(response) {					
				if(response.body == null) {
					alertService.showAlert(_this.$bvModal, 'danger', 'Error!', 'Ocurrio un error al obtener los datos');
					return;
				}
				if(response.body && response.body.status == 'ERROR') {
					alertService.showAlert(_this.$bvModal, 'danger', 'Error!', response.body.message);
					return;
				}
				if(response.body.length > 0) {
					for (let value of response.body) {
						//if(value.activoDatoParametrico == 1) {
							value.descripcionDatoParametrico =  value.col1DatoParametrico + " - " + value.descripcionDatoParametrico;
							_this.diagnosticos.push(value);
						//}
					}
				} 
			}, function(error) { 
				_this.submited = false;
				generalService.showRequestErrors(error, _this.$bvModal);
				return;
			});
		},
		getTipoInternacion: function() {
			_this.tiposInternacion = [];
			datosParametricosService.getTipoInternacion({}).then(function(response) {					
				if(response.body == null) {
					alertService.showAlert(_this.$bvModal, 'danger', 'Error!', 'Ocurrio un error al obtener los datos');
					return;
				}
				if(response.body && response.body.status == 'ERROR') {
					alertService.showAlert(_this.$bvModal, 'danger', 'Error!', response.body.message);
					return;
				}
				if(response.body.length > 0) {
					for (let value of response.body) {
						//if(value.activoDatoParametrico == 1) {
							_this.tiposInternacion.push(value);
						//}
					}
				} 
			}, function(error) { 
				_this.submited = false;
				generalService.showRequestErrors(error, _this.$bvModal);
				return;
			});
		},
		getSedes: function() {
			_this.sedes = [{idSede:"", nombreSede:"Sede"}];
			sedeService.get({}).then(function(response) {					
				if(response.body == null) {
					alertService.showAlert(_this.$bvModal, 'danger', 'Error!', 'Ocurrio un error al obtener los datos');
					return;
				}
				if(response.body && response.body.status == 'ERROR') {
					alertService.showAlert(_this.$bvModal, 'danger', 'Error!', response.body.message);
					return;
				}
				if(response.body.length > 0) {
					for (let value of response.body) {
						//if(value.activoObraSocial == 1) {
							_this.sedes.push(value);
						//}
					}
				} 
			}, function(error) { 
				_this.submited = false;
				generalService.showRequestErrors(error, _this.$bvModal);
				return;
			});
		},
		limpiar() {
			this.search = JSON.parse(search);
			if(!this.noDataGet)
				this.getData();
			else
				this.data = [];
		},
	}
}

